export default __webpack_public_path__ + "static/media/categoria_espacio.adcf4fb0.svg";